import { isBrowser } from './dom.esm.js';

function identifyBrowser() {
  if (process.env.NODE_ENV !== 'test') {
    if (isBrowser) {
      // Get the user-agent string
      var userAgentString = navigator.userAgent;

      // Detect Chrome
      var _isChrome = userAgentString.indexOf('Chrome') > -1;

      // Detect Internet Explorer
      var _isIE = userAgentString.indexOf('MSIE') > -1 || userAgentString.indexOf('rv:') > -1;

      // Detect Firefox
      var _isFirefox = userAgentString.indexOf('Firefox') > -1;

      // Detect Safari
      var _isSafari = userAgentString.indexOf('Safari') > -1;

      // Discard Safari since it also matches Chrome
      if (_isChrome && _isSafari) _isSafari = false;

      // Detect Opera
      var _isOpera = userAgentString.indexOf('OP') > -1;

      // Discard Chrome since it also matches Opera
      if (_isChrome && _isOpera) _isChrome = false;
      return {
        isChrome: _isChrome,
        isIE: _isIE,
        isFirefox: _isFirefox,
        isSafari: _isSafari,
        isOpera: _isOpera
      };
    }
  }
  return {};
}
var _identifyBrowser = identifyBrowser(),
  isChrome = _identifyBrowser.isChrome,
  isIE = _identifyBrowser.isIE,
  isFirefox = _identifyBrowser.isFirefox,
  isSafari = _identifyBrowser.isSafari,
  isOpera = _identifyBrowser.isOpera;

export { isChrome, isFirefox, isIE, isOpera, isSafari };
//# sourceMappingURL=browser.esm.js.map
